import { type FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import ClaimModal from '@components/Modals/claim/ClaimModal';
import ModalSellResource from '@components/Modals/sell/ModalSellResource';
import ModalTcoinExplain from '@components/Modals/TcoinExplain/ModalTcoinExplain';

import { HeaderAnimationProvider } from '@/context/HeaderAnimationContext';
import { MineResourceProvider } from '@/context/MineResourceContext';
import { ModalProvider } from '@/context/ModalProvider';
import { Presentation } from '@/pages/Presentation/Presentation';

import { AdsProvider } from '../Ads/AdsProvider';
import { InitHooksProvider } from '../common/InitHooksProvider/InitHookdsProvider';
import { MainContainer } from '../common/MainContainer/MainContainer';
import { DesktopContainer } from '../DesktopContainer/DesktopContainer';
import { NativeGroupInvite } from '../Friends/NativeGroupInvite/NativeGroupInvite';
import { FullscreenModals } from '../FullscreenModals/FullscreenModals';
import { Intro } from '../Intro/Intro';
import { ClaimLotteryRewardsModal } from '../Lottery/ClaimLotteryRewards/ClaimLotteryRewardsModal';
import EarnRewardsModal from '../Modals/EarnRewardsModal/EarnRewardsModal';
import HelpModal from '../Modals/HelpModal/HelpModal';
import { Modal } from '../Modals/Modal/modal';
import { OpenChest } from '../Modals/OpenChest/OpenChest';
import { FactoriesBoostModal } from '../Modals/PlantBoostModal/FactoriesBoostModal/FactoriesBoostModal';
import { QuarriesBoostModal } from '../Modals/PlantBoostModal/QuarriesBoostModal/QuarriesBoostModal';
import { WorkshopBoostModal } from '../Modals/PlantBoostModal/WorkshopBoostModal/WorkshopBoostModal';
import { StockOverflow } from '../Notifications/StockOverflow/StockOverflow';
import { PromoCodeRewardModal } from '../Shop/PromoCodeTab/PromoCodeRewardModal/PromoCodeRewardModal';
import Tapbar from '../TapBar/TapBar';
import { Tutorial } from '../Tutorial/Tutorial';

const Layout: FC = () => {
  return (
    <DesktopContainer>
      <AdsProvider>
        <Intro>
          <Tutorial>
            <ModalProvider>
              <Modal>
                <MineResourceProvider>
                  <InitHooksProvider />
                  {Capacitor.isNativePlatform() && <NativeGroupInvite />}
                  <HeaderAnimationProvider>
                    <MainContainer>
                      <Outlet />
                    </MainContainer>
                    <Tapbar />
                    <ModalTcoinExplain />
                    <ModalSellResource />
                    <ClaimModal />
                    <FactoriesBoostModal />
                    <QuarriesBoostModal />
                    <WorkshopBoostModal />
                    <EarnRewardsModal />
                    <HelpModal />
                    <Presentation />
                    <StockOverflow />
                    <OpenChest />
                    <PromoCodeRewardModal />
                    <ClaimLotteryRewardsModal />
                  </HeaderAnimationProvider>
                </MineResourceProvider>
                <FullscreenModals />
              </Modal>
            </ModalProvider>
          </Tutorial>
        </Intro>
      </AdsProvider>
    </DesktopContainer>
  );
};

export { Layout };
